import { Link } from "react-router-dom";

/** Inventory in one place: what the shop holds, and what is waiting to join it. */
export function InventoryTabs({ active, reviewCount }: { active: "stock" | "review"; reviewCount: number }) {
  const tab = (on: boolean) =>
    `flex flex-1 items-center justify-center gap-1.5 rounded-btn px-3 py-2 text-sm font-medium transition-colors sm:flex-none ${
      on ? "bg-accent text-ink" : "text-muted hover:bg-surface-strong hover:text-white"
    }`;
  return (
    <nav className="flex w-full gap-1 rounded-btn bg-surface p-1 sm:w-auto" aria-label="Inventory">
      <Link to="/cards" className={tab(active === "stock")} aria-current={active === "stock" ? "page" : undefined}>
        Stock
      </Link>
      <Link to="/drafts" className={tab(active === "review")} aria-current={active === "review" ? "page" : undefined}>
        Review
        {reviewCount > 0 && (
          <span
            className={`inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-semibold ${
              active === "review" ? "bg-ink text-accent" : "bg-warn text-ink"
            }`}
          >
            {reviewCount > 99 ? "99+" : reviewCount}
            <span className="sr-only"> waiting</span>
          </span>
        )}
      </Link>
    </nav>
  );
}
